import React from "react";
import { useOutletContext } from "react-router-dom";
import ComponentsListing from "./ComponentsListing";
import { OutletContextType } from "../../../types/types";


const Components: React.FC = () => {

  const { setSelectedEntity, refreshTrigger } =
    useOutletContext<OutletContextType>();

  return (
    <ComponentsListing
      onEditForm={(id) => {
        setSelectedEntity && setSelectedEntity("components", id);
      }}
      refreshTrigger={refreshTrigger}
    />
  );
};

export default Components;
